import { useMemo, useState } from "react"
import { FetchState } from "shared/api"
import { DashBoardConfigure, DashBoardItemData } from "../types"

type useSubSourceProps<T, KeyType, MasterType, DataType> = {
	searchId: number | undefined
  source: string
	defaultKeyValue: KeyType | null
	configure: DashBoardConfigure<T>
	dashBoardItems: DashBoardItemData[]
	findMaster: (has: boolean, searchId: number | undefined) => FetchState<MasterType>
	findData: (keyValue: KeyType | null) => FetchState<DataType>
}
export const useSubSource = <T, KeyType, MasterType, DataType>({
	searchId,
	source,
	defaultKeyValue,
	configure,
	dashBoardItems,
	findMaster,
	findData
}: useSubSourceProps<T, KeyType, MasterType, DataType>) => {
  const [keyValue, setKeyValue] = useState<KeyType | null>(defaultKeyValue)

  const keys = useMemo(
    () => [
      Object.keys(configure.axis).filter((key) => configure.axis[key].source === source),
      Object.keys(configure.value).filter((key) => configure.value[key].source === source)
    ].flat(),
    [configure, source]
  )
  const has = useMemo(
    () => {
      if (keys.length === 0) return false
      return dashBoardItems.some((item) => item.options?.some((line) => keys.indexOf(line.value) >= 0) ?? false)
    },
    [dashBoardItems, keys]
  )
  const masterState = findMaster(has, searchId)
  const dataState = findData(keyValue)

	return useMemo(() => ({
		keys, has,
		keyValue, setKeyValue,
		masterState, dataState
	}), [
		keys, has,
		keyValue, setKeyValue,
		masterState, dataState
	])
}